var getQueryVariable = require('./helpers').getQueryVariable;

$(document).ready(function () {
    var customSelect = $('.js-custom-select'),
        selectBtn = customSelect.find('.custom-select__btn'),
        url = window.location.href;

    if (customSelect.length > 0) {
        selectBtn.on('click', function () {
            var btn = $(this);
            toggleOptList(btn);
        });

        selectBtn.on('blur', function () {
            var btn = $(this);
            deactivateSelect(btn);
        });

        customSelect.each(function (i, select) {
            var selectOptions = $(select).find('.custom-select__item'),
                nativeSelectWidget = $(select).find('.custom-select__fallback-select'),
                selectIndex = getIndex(select);

            updateValue(select, selectIndex);
            nativeSelectWidget.attr('tabindex', -1);

            selectOptions.each(function (i, option) {
                $(option).on('mousedown', function () {
                    updateValue(select, i);
                })
            });
            $(select).on('keydown', function (e) {
                var length = selectOptions.length,
                    index = getIndex(select);

                if (e.keyCode === 40 && index < length - 1) {
                    e.preventDefault();
                    index++;
                }

                if (e.keyCode === 38 && index > 0) {
                    e.preventDefault();
                    index--;
                }

                updateValue(select, index);
            });
        });

        // if on search page
        if ( url.indexOf('search') >= 0 ) {
            var select = $('.products-search').find('.custom-select'),
                categoryId = getQueryVariable('categoryId').toString();

            select.each(function (i, select) {
                var selectOptions = $(select).find('.custom-select__item');

                selectOptions.each(function (i, option) {
                    if ($(option).attr('data-category-id') === categoryId)
                        updateValue(select, i);
                });
            });
        }
    }

    function toggleOptList(btn) {
        btn.focus();
        btn.parent().toggleClass('custom-select__widget--open');
    }

    function deactivateSelect(btn) {
        var customSelectWidget = btn.parent();
        if (!customSelectWidget.hasClass('custom-select__widget--open')) return;

        customSelectWidget.removeClass('custom-select__widget--open');
    }

    function getIndex(select) {
        var nativeSelect = $(select).find('.custom-select__fallback-select')[0];
        return nativeSelect.selectedIndex;
    }

    function updateValue(select, index) {
        var customSelect = $(select),
            nativeSelect = customSelect.find('.custom-select__fallback-select')[0],
            previousSelectedIndex = nativeSelect.selectedIndex,
            selectedValue = customSelect.find('.custom-select__label'),
            selectOptions = customSelect.find('.custom-select__item'),
            selectedOptionText = $(selectOptions[index]).text();

        selectOptions.each(function (i, option) {
            $(option).attr('aria-selected', 'false');
        });
        $(selectOptions[index]).attr('aria-selected', 'true');
        nativeSelect.selectedIndex = index;
        if (previousSelectedIndex !== index) {
            $(nativeSelect).trigger('onchange');
        }

        selectedValue.html(selectedOptionText);
        highlightOption(select, selectOptions[index]);

    }

    function highlightOption(select, option) {
        var selectOptions = customSelect.find('.custom-select__item'),
            hasHighlightedOption = false;

        if ($(select).find('.custom-select__list').children('.custom-select__item--highlighted').length > 0) {
            hasHighlightedOption = true;
        } else {
            hasHighlightedOption = false;
        }

        if (hasHighlightedOption) {
            selectOptions.removeClass('custom-select__item--highlighted');
        }
        $(option).addClass('custom-select__item--highlighted');
    }
});